import { JSConn } from "@/utilities/js-conn";

export default {
  name: "theNavbar",
  data() {
    return {};
  },
  computed: {
    companyName: function() {
      return this.$store.getters.companyName;
    },
    isLoggedIn: function() {
      return this.$store.getters.isLoggedIn;
    },
    isAdmin: function() {
      return this.$store.getters.isAdmin;
    },
    isFieldWorker: function() {
      return this.$store.getters.isFieldWorker;
    },
    showAdminNavbar: function() {
      if (this.isLoggedIn && this.isAdmin) {
        return true;
      } else {
        return false;
      }
    },
    showFieldWorkerNavbar: function() {
      if (this.isLoggedIn && this.isFieldWorker) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    logOut: function() {
      const jsConn = new JSConn();
      this.$store.dispatch("logOutUser", jsConn).then(() => {
        this.$router.push("/log-in");
      });
    },
  },
};
